import { Injectable } from "@angular/core";
import { TypeCPVClass } from "../../models/TypeCPVClass";
import { TypeDescMarche } from "../../models/TypeDescMarche";
import { TypeFournitures } from "../../models/TypeFournitures";
import { TypeLieu } from "../../models/TypeLieu";
import { TypeObjCPV } from "../../models/TypeObjCPV";
import { TypeTravaux } from "../../models/TypeTravaux";
import { TypeVoie } from "../../models/TypeVoie";
import { AvisDataTransferService } from "../../../../../shared/services/avis-data-transfer.service";

@Injectable({
    providedIn: 'root'
})


export class DescriptionService {

    constructor(private avisDataTransferService: AvisDataTransferService) {
    }
    setValueFromControlName(value: any, attribut: any[]) {
        if (value && value != '') {
            attribut[attribut.length++] = value;
        }
    }

    public getDecription(controls, formExtractorService): TypeDescMarche {

        const objetComplementaire_iters = formExtractorService.getIndexes(Array.from(controls.keys()), ['_SepSep_TypeCPVClass'], '_SepSep_Annulation_SepSep_TypeDescMarche_SepSep_TypeObjCPV_index_');
        let objetComplementaire_iter = 0;

        const description = this.avisDataTransferService.getFormData().jsonSaisieFormulaire.ann.mapa.annulationFromMAPA.description;
        description.marcheServices = controls.get('_SepSep_Annulation_SepSep_TypeDescMarche_SepAtt_marcheServices')
        description.objet = controls.get('_SepSep_Annulation_SepSep_TypeDescMarche_SepAtt_objet')

        const lieuExecutionLivraison = controls.get('_SepSep_Annulation_SepSep_TypeDescMarche_SepAtt_lieuExecutionLivraisonCB')

        if(lieuExecutionLivraison) {
            description.lieuLivraison = null;
            description.lieuExecution = null;

            description.lieuExecutionLivraison = new TypeLieu();
            description.lieuExecutionLivraison.ville = controls.get('_SepSep_Annulation_SepSep_TypeDescMarche_lieuExecutionLivraison_SepSep_TypeLieu_SepAtt_ville')
            description.lieuExecutionLivraison.cp = controls.get('_SepSep_Annulation_SepSep_TypeDescMarche_lieuExecutionLivraison_SepSep_TypeLieu_SepAtt_cp')

            description.lieuExecutionLivraison.voie = new TypeVoie();
            description.lieuExecutionLivraison.voie.typevoie = controls.get('_SepSep_Annulation_SepSep_TypeDescMarche_lieuExecutionLivraison_SepSep_TypeLieu_SepSep_TypeVoie_SepAtt_typevoie')
            description.lieuExecutionLivraison.voie.nomvoie = controls.get('_SepSep_Annulation_SepSep_TypeDescMarche_lieuExecutionLivraison_SepSep_TypeLieu_SepSep_TypeVoie_SepAtt_nomvoie')
            description.lieuExecutionLivraison.voie.num = controls.get('_SepSep_Annulation_SepSep_TypeDescMarche_lieuExecutionLivraison_SepSep_TypeLieu_SepSep_TypeVoie_SepAtt_num')
        } else {
            description.lieuExecutionLivraison = null;

            description.lieuLivraison = new TypeLieu();
            description.lieuLivraison.ville = controls.get('_SepSep_Annulation_SepSep_TypeDescMarche_lieuLivraison_SepSep_TypeLieu_SepAtt_ville')
            description.lieuLivraison.cp = controls.get('_SepSep_Annulation_SepSep_TypeDescMarche_lieuLivraison_SepSep_TypeLieu_SepAtt_cp')

            description.lieuLivraison.voie = new TypeVoie();
            description.lieuLivraison.voie.typevoie = controls.get('_SepSep_Annulation_SepSep_TypeDescMarche_lieuLivraison_SepSep_TypeLieu_SepSep_TypeVoie_SepAtt_typevoie')
            description.lieuLivraison.voie.num = controls.get('_SepSep_Annulation_SepSep_TypeDescMarche_lieuLivraison_SepSep_TypeLieu_SepSep_TypeVoie_SepAtt_num')
            description.lieuLivraison.voie.nomvoie = controls.get('_SepSep_Annulation_SepSep_TypeDescMarche_lieuLivraison_SepSep_TypeLieu_SepSep_TypeVoie_SepAtt_nomvoie')

            description.lieuExecution = new TypeLieu();
            description.lieuExecution.ville = controls.get('_SepSep_Annulation_SepSep_TypeDescMarche_lieuExecution_SepSep_TypeLieu_SepAtt_ville')
            description.lieuExecution.cp = controls.get('_SepSep_Annulation_SepSep_TypeDescMarche_lieuExecution_SepSep_TypeLieu_SepAtt_cp')

            description.lieuExecution.voie = new TypeVoie();
            description.lieuExecution.voie.num = controls.get('_SepSep_Annulation_SepSep_TypeDescMarche_lieuExecution_SepSep_TypeLieu_SepSep_TypeVoie_SepAtt_num')
            description.lieuExecution.voie.typevoie = controls.get('_SepSep_Annulation_SepSep_TypeDescMarche_lieuExecution_SepSep_TypeLieu_SepSep_TypeVoie_SepAtt_typevoie')
            description.lieuExecution.voie.nomvoie = controls.get('_SepSep_Annulation_SepSep_TypeDescMarche_lieuExecution_SepSep_TypeLieu_SepSep_TypeVoie_SepAtt_nomvoie')
        }
        description.isLieuExecutionLivraison = lieuExecutionLivraison;
        description.marcheFournitures = new TypeFournitures();
        description.marcheFournitures.locationVente = controls.get('_SepSep_Annulation_SepSep_TypeDescMarche_SepSep_TypeFournitures_SepAtt_locationVente')
        description.marcheFournitures.location = controls.get('_SepSep_Annulation_SepSep_TypeDescMarche_SepSep_TypeFournitures_SepAtt_location')
        description.marcheFournitures.achat = controls.get('_SepSep_Annulation_SepSep_TypeDescMarche_SepSep_TypeFournitures_SepAtt_achat')
        description.marcheFournitures.creditBail = controls.get('_SepSep_Annulation_SepSep_TypeDescMarche_SepSep_TypeFournitures_SepAtt_creditBail')

        description.marcheTravaux = new TypeTravaux();
        description.marcheTravaux.conceptionRealisation = controls.get('_SepSep_Annulation_SepSep_TypeDescMarche_SepSep_TypeTravaux_SepAtt_conceptionRealisation')
        description.marcheTravaux.execution = controls.get('_SepSep_Annulation_SepSep_TypeDescMarche_SepSep_TypeTravaux_SepAtt_execution')

        description.cpv = new TypeObjCPV();

        description.cpv.objetPrincipal = new TypeCPVClass();
        description.cpv.objetPrincipal.classPrincipale = controls.get('_SepSep_Annulation_SepSep_TypeDescMarche_SepSep_TypeObjCPV_SepSep_TypeCPVClass_SepAtt_classPrincipale')
        description.cpv.objetPrincipal.classSupplementaire = controls.get('_SepSep_Annulation_SepSep_TypeDescMarche_SepSep_TypeObjCPV_SepSep_TypeCPVClass_SepAtt_classSupplementaire');

        objetComplementaire_iter = 0;
        objetComplementaire_iters.forEach(() => {
            description.cpv.objetComplementaire[objetComplementaire_iter] = new TypeCPVClass();
            description.cpv.objetComplementaire[objetComplementaire_iter].classPrincipale = controls.get('_SepSep_Annulation_SepSep_TypeDescMarche_SepSep_TypeObjCPV_index_' + (Number(objetComplementaire_iter + 1)) + '_SepSep_TypeCPVClass_SepAtt_classPrincipale')
            description.cpv.objetComplementaire[objetComplementaire_iter].classSupplementaire = controls.get('_SepSep_Annulation_SepSep_TypeDescMarche_SepSep_TypeObjCPV_index_' + (Number(objetComplementaire_iter + 1)) + '_SepSep_TypeCPVClass_SepAtt_classSupplementaire');
            objetComplementaire_iter++;
        });

        return description;
    }
}
